import * as React from 'react'
import {H1} from '@frontrow/console/src/components/typography'

import JobsForm from '@frontrow/console/src/components/pages/jobs-page/jobs-form'

export default function JobsPageContainer(): React.ReactElement {
  return (
    <React.Fragment>
      <H1>Jobs</H1>
      <JobsForm />
    </React.Fragment>
  )
}
